import { render, staticRenderFns } from "./department-tree.vue?vue&type=template&id=c471f958&scoped=true"
import script from "./department-tree.vue?vue&type=script&lang=ts"
export * from "./department-tree.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c471f958",
  null
  
)

export default component.exports